module.exports = __webpack_public_path__ + "static/media/pinned.edb0c146.svg";